import React from 'react'
import styled from 'styled-components'

import { Box, Button, Text } from '@usap/uicomponents'

export const Container = styled(Box)`
  border-top: 1px solid #E0E0E0;
`

export const ResponsiveContainer = styled(Box)`
  flex-direction: column;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: row;
  }
`

export const OrderItemBox = styled(Box)`
  width: 100%;
  padding: 4px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: 65%;
    padding: 16px;
  }
`

export const OrderDetailsBox = styled(Box)`
  padding-bottom: 0px;
  flex-direction: row;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    padding-bottom: 8px;
  }
`

export const OrderDetailsTextBox = styled(Box)`
  width: 65%;
  padding: 8px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: 80%;
  }
`

export const ActionContainer = styled(Box)`
  align-items: center;
  padding: 4px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    padding: 16px;
  }
`

export const ActionTrackContainer = styled(Box)`
  padding-top: 2px;
  padding-bottom: 2px;
`

export const LiveChat = styled.button`
  color: #05629B;
  cursor: pointer;
  background: none;
  padding: 0;
  font-size: 12px;
  font-weight: bold;
`

export const KitContainer = styled(Box)`
  width: 100%;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: 80%;
  }
`

export const CorePriceContainer = styled(Box)`
  position: relative;
  flex-direction: row;
`

export const CorePriceTooltip = styled(Box)`
  position: absolute;
  top: 20px;
  right: 15px;
  box-shadow: 0 0 10px 0 #8e8d8d;
  z-index: 15;
  border: 1 solid #f5f5f5l

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    top: -94px;
    right: 86px;
  }
`

export const CorePriceTooltipContent = styled.div`
  position: relative;
  z-index: 15px;
  font-size: 12px;
  line-height: 18px;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 4px;
  flex-wrap: wrap;

`

export const CorePriceTooltipArrow = styled(Box)`
  position: absolute;
  top: 75px;
  right: 27px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    right: 224px;
  }
`

export const CorePriceHelpText = styled(Text)`
  text-decoration: underline;
  color: #2d488b;
  cursor: pointer;
  margin-left: 4px;
  z-index: ${props => (props.hasCoreChargeText ? 16 : 0)};
`

export const OrderDetailsBlueButton = styled(Button)`
  width: 100%;
  height: 40px;
  background-color: #2e4787;
  border: 2px solid #2e4787;
  border-radius: 32px;
  cursor: pointer;

  &:hover {
    background-color: #3557b1;
    border: 2px solid #3557b1;
  }

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: 300px;
  }
`
